<!--
 * @Author: zhongtao
 * @LastEditors: zhongtao
-->
<script>
import iframeMixin from '../iframeMixin.vue'

export default {
  mixins: [iframeMixin],
  computed: {
    url() {
     return '/ureport/preview?_u=mysql:matchReport.ureport.xml&_i=1'
    },
  },
}
</script>
